var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutubeIconinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3662 8.50159C30.0205 7.21637 29.0072 6.20325 27.7222 5.85718C25.3746 5.21484 15.984 5.21484 15.984 5.21484C15.984 5.21484 6.59381 5.21484 4.24622 5.83282C2.9859 6.17853 1.94788 7.21655 1.60217 8.50159C0.984375 10.849 0.984375 15.7172 0.984375 15.7172C0.984375 15.7172 0.984375 20.61 1.60217 22.9329C1.94824 24.2179 2.96118 25.231 4.2464 25.5771C6.61853 26.2196 15.9844 26.2196 15.9844 26.2196C15.9844 26.2196 25.3746 26.2196 27.7222 25.6016C29.0074 25.2557 30.0205 24.2426 30.3666 22.9576C30.9842 20.61 30.9842 15.7419 30.9842 15.7419C30.9842 15.7419 31.0089 10.849 30.3662 8.50159ZM12.9943 20.2147V11.2198L20.803 15.7172L12.9943 20.2147Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube-icon.inline.dc4bb37471328e8fc9594613bf045303.svg";